import React from "react";

export default function ServicesHero() {
  return (
    <header className="services-hero">
      <div className="container text-center">
        <div className="mu-eyebrow on-purple">Services &amp; Rate Card</div>
        <h1>Everything Your Music Career Needs</h1>
        <p>
          From distribution to press coverage, pick the services that fit where you are in
          your career — no bundles you don't need.
        </p>
        <a href="#contact" className="btn-mu-solid">Talk to Our Team &rarr;</a>
      </div>
    </header>
  );
}
